import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileExtensionValidator(allowedFileExtensions: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file: File | null = control.value;

    if (!file) {
      return null;
    }

    const extension: string | undefined = file.name?.split('.')?.pop()?.toLowerCase();

    if (!extension || !allowedFileExtensions.includes(extension)) {
      return {
        invalidFileExtension: {
          allowedFileExtensions: allowedFileExtensions.join(', '),
        },
      };
    }

    return null;
  };
}

export function fileSizeValidator(maxFileSizeInBytes: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file: File | null = control.value;

    if (!file || !file.size) {
      return null;
    }

    if (file.size > maxFileSizeInBytes) {
      return {
        maxFileSize: {
          maxSizeInMb: maxFileSizeInBytes / 1000000,
        },
      };
    }

    return null;
  };
}
